// extracted by mini-css-extract-plugin
module.exports = {"summary":"summary-694ki","passengers":"passengers-2uLo5"};